import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomeComponent} from './home.component';
import {MandiriModule} from './virtual-account/mandiri/mandiri.module';
import {PermataModule} from './virtual-account/permata/permata.module';
import {BcaModule} from './virtual-account/bca/bca.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedComponentModule} from '../../shared/component/shared-component.module';
import {MandirisyariahModule} from './virtual-account/mandiri-syariah/mandirisyariah.module';
import {DanamonModule} from './virtual-account/danamon/danamon.module';
import {CimbModule} from './virtual-account/cimb/cimb.module';
import {CreditCardComponent} from './credit-card/credit-card.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ExpiryDateComponent} from './credit-card/expiry-date/expiry-date.component';
import {GeneralComponent} from './credit-card/general/general.component';
import {BankSpecificComponent} from './credit-card/bank-specific/bank-specific.component';
import {OvoModule} from './e-wallet/ovo/ovo.module';
import {PageNotFoundComponent} from './error-page/page-unauthorized/page-not-found/page-not-found.component';
import {BriSyariahModule} from './virtual-account/bri-syariah/bri-syariah.module';
import {AlfaModule} from './convenience-store/alfa/alfa.module';
import {BriDirectDebitComponent} from './direct-debit/bri-direct-debit/bri-direct-debit.component';
import {CommonTableScenarioComponent} from './direct-debit/common-table-scenario/common-table-scenario.component';
import {BriModule} from './virtual-account/bri/bri.module';
import {ShopeePayComponent} from './e-wallet/shopee-pay/shopee-pay.component';
import {PaymentShopeepayComponent} from './e-wallet/shopee-pay/payment-shopeepay/payment-shopeepay.component';
import {PaymentResultShopeepayComponent} from './e-wallet/shopee-pay/payment-result-shopeepay/payment-result-shopeepay.component';
import {RouterModule} from '@angular/router';
import {IndomaretModule} from './convenience-store/indomaret/indomaret.module';
import {DokuVaModule} from './virtual-account/doku-va/doku-va.module';
import {BniComponent} from './virtual-account/bni/bni.component';
import {BncComponent} from './virtual-account/bnc/bnc.component';
import {DirectTransferBcaComponent} from './direct-transfer/direct-transfer-bca/direct-transfer-bca.component';
import {RekeningBersamaBcaComponent} from './rekening-bersama/rekening-bersama-bca/rekening-bersama-bca.component';
import {AkulakuComponent} from './paylater/akulaku/akulaku.component';
import {AkuLakuAuthComponent} from './paylater/akulaku/auth/akulakuauth.component';
import {AkuLakuInquiryComponent} from './paylater/akulaku/inquiry/akulakuinquiry.component';
import {KredivoComponent} from './paylater/kredivo/kredivo.component';
import {KredivoAuthComponent} from './paylater/kredivo/auth/kredivoauth.component';
import {KredivoInquiryComponent} from './paylater/kredivo/inquiry/kredivoinquiry.component';
import {AkuLakuAnotherPageComponent} from './paylater/akulaku/inquiry/akulakuanotherpage.component';
import {IndodanaAuthComponent} from './paylater/indodana/auth/indodanaauth.component';
import {IndodanaInquiryComponent} from './paylater/indodana/inquiry/indodanainquiry.component';
import {IndodanaComponent} from './paylater/indodana/indodana.component';
import {BniModule} from './virtual-account/bni/bni.module';
import {BncModule} from './virtual-account/bnc/bnc.module';
import {BtnModule} from './virtual-account/btn/btn.module';
import {BniSnapModule} from './virtual-account/bni-snap/bni-snap.module';
import {BriSnapModule} from './virtual-account/bri-snap/bri-snap.module';
import {MandiriSnapModule} from './virtual-account/mandiri-snap/mandiri-snap.module';
import {LinkajaModule} from './e-wallet/linkaja/linkaja.module';
import {DanamonSnapModule} from './virtual-account/danamon-snap/danamon-snap.module';
import {MaybankSnapModule} from './virtual-account/maybank-snap/maybank-snap.module';
import {PermataSnapModule} from './virtual-account/permata-snap/permata-snap.module';
import {KlikBcaModule} from './virtual-account/klik-bca/klik-bca.module';
import { InquiryBsiSnapComponent } from './virtual-account/bsi-snap/inquiry-bsi-snap/inquiry-bsi-snap.component';
import { PaymentBsiSnapComponent } from './virtual-account/bsi-snap/payment-bsi-snap/payment-bsi-snap.component';
import { PaymentResultBsiSnapComponent } from './virtual-account/bsi-snap/payment-result-bsi-snap/payment-result-bsi-snap.component';

@NgModule({
  declarations: [
    HomeComponent,
    CreditCardComponent,
    ExpiryDateComponent,
    GeneralComponent,
    BankSpecificComponent,
    PageNotFoundComponent,
    BriDirectDebitComponent,
    CommonTableScenarioComponent,
    ShopeePayComponent,
    PaymentShopeepayComponent,
    PaymentResultShopeepayComponent,
    BniComponent,
    BncComponent,
    DirectTransferBcaComponent,
    RekeningBersamaBcaComponent,
    AkulakuComponent,
    AkuLakuAuthComponent,
    AkuLakuInquiryComponent,
    KredivoComponent,
    KredivoAuthComponent,
    KredivoInquiryComponent,
    AkuLakuAnotherPageComponent,
    IndodanaAuthComponent,
    IndodanaInquiryComponent,
    IndodanaComponent,
    InquiryBsiSnapComponent,
    PaymentBsiSnapComponent,
    PaymentResultBsiSnapComponent,
  ],
    imports: [
        CommonModule,
        IndomaretModule,
        AlfaModule,
        BcaModule,
        BriSyariahModule,
        MandiriModule,
        MandiriSnapModule,
        MandirisyariahModule,
        DanamonModule,
        CimbModule,
        DokuVaModule,
        OvoModule,
        LinkajaModule,
        PermataModule,
        BriModule,
        BriSnapModule,
        DanamonSnapModule,
        BniModule,
        BniSnapModule,
        BncModule,
        BtnModule,
        ReactiveFormsModule,
        SharedComponentModule,
        FormsModule,
        NgbModule,
        RouterModule,
        MaybankSnapModule,
        PermataSnapModule,
        KlikBcaModule
    ]
})
export class HomeModule { }
